module.exports = __webpack_public_path__ + "img/eefef06.png";